module.exports = __webpack_public_path__ + "media/images/diy/bg-shape-7-538924cc9f19dfb05559cc64109f03cd.svg";